<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import {CommonNs} from "@shared/types";

export default defineComponent({
  name: 'AbstractInput',
  props: {
    type: {
      type: String as unknown as PropType<CommonNs.InputType>,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
  },
});

</script>
